import React, { useState } from 'react';
import Split from 'react-split';
import { Box } from '@mui/material';
import DocumentEditor from '../DocumentEditor/DocumentEditor';
import ChatSection from '../ChatSection/ChatSection';
import './SplitLayout.css';

const SplitLayout: React.FC = () => {
  // Default split sizes: 65% for editor, 35% for chat
  const [sizes, setSizes] = useState([65, 35]);

  return (
    <Box sx={{ height: '100%', width: '100%', overflow: 'hidden' }}>
      <Split
        sizes={sizes}
        minSize={200}
        expandToMin={false}
        gutterSize={2}
        gutterAlign="center"
        snapOffset={30}
        dragInterval={1}
        direction="horizontal"
        cursor="col-resize"
        className="split-layout"
        onDragEnd={(newSizes) => {
          setSizes(newSizes);
        }}
      >
        <Box
          sx={{
            'height': '100%',
            'overflow': 'hidden',
            '& .quill': { height: '100%' },
          }}
        >
          <DocumentEditor />
        </Box>
        <Box sx={{ height: '100%', overflow: 'hidden' }}>
          <ChatSection />
        </Box>
      </Split>
    </Box>
  );
};

export default SplitLayout;
